"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayPlanModule = void 0;
const types_1 = require("../main/types");
class DayPlanModule extends types_1.DayPlanModuleType {
    constructor(userId, date, moduleId, moduleTitle, moduleIcon, includedDate) {
        super(userId, moduleId, moduleTitle, moduleIcon);
        this.expectedStudyDate = date;
        this.includedDate = includedDate;
        this.date = date;
    }
    isEqual(other) {
        var _a, _b;
        return this.id === other.id &&
            this.userId === other.userId &&
            this.moduleId === other.moduleId &&
            this.date.isEqual(other.date) &&
            this.moduleTitle === other.moduleTitle &&
            this.moduleIcon === other.moduleIcon &&
            this.progress === other.progress &&
            this.highestCorrectStreak === other.highestCorrectStreak &&
            this.estimatedCompletionTime === other.estimatedCompletionTime &&
            this.actualStudyTime === other.actualStudyTime &&
            this.isFinished === other.isFinished &&
            this.isReviewFinished === other.isReviewFinished &&
            this.isAcquisitionFinished === other.isAcquisitionFinished &&
            this.acquisitionTarget === other.acquisitionTarget &&
            this.acquisitionProgress === other.acquisitionProgress &&
            this.reviewTarget === other.reviewTarget &&
            this.reviewProgress === other.reviewProgress &&
            ((_a = this.lastStudyDate) === null || _a === void 0 ? void 0 : _a.valueOf()) === ((_b = other.lastStudyDate) === null || _b === void 0 ? void 0 : _b.valueOf()) &&
            this.includedDate.valueOf() === other.includedDate.valueOf() &&
            JSON.stringify(this.reviewCardIds) === JSON.stringify(other.reviewCardIds) &&
            this.expectedStudyDate.isEqual(other.expectedStudyDate);
    }
}
exports.DayPlanModule = DayPlanModule;
DayPlanModule.converter = {
    toFirestore(data) {
        return {
            userId: data.userId,
            date: data.date,
            moduleId: data.moduleId,
            moduleTitle: data.moduleTitle,
            moduleIcon: data.moduleIcon,
            progress: data.progress,
            highestCorrectStreak: data.highestCorrectStreak,
            estimatedCompletionTime: data.estimatedCompletionTime,
            actualStudyTime: data.actualStudyTime,
            isFinished: data.isFinished,
            isReviewFinished: data.isReviewFinished,
            isAcquisitionFinished: data.isAcquisitionFinished,
            acquisitionTarget: data.acquisitionTarget,
            acquisitionProgress: data.acquisitionProgress,
            reviewTarget: data.reviewTarget,
            reviewProgress: data.reviewProgress,
            lastStudyDate: data.lastStudyDate,
            includedDate: data.includedDate,
            reviewCardIds: data.reviewCardIds,
            expectedStudyDate: data.expectedStudyDate,
            isAssigned: data.isAssigned
        };
    },
    fromFirestore(snapshot) {
        var _a, _b, _c;
        const documentData = snapshot.data();
        const id = snapshot.id;
        const userId = documentData.userId;
        const date = documentData.date;
        const moduleId = documentData.moduleId;
        const moduleTitle = documentData.moduleTitle;
        const moduleIcon = documentData.moduleIcon;
        const includedDate = documentData.includedDate;
        const isAssigned = (_a = documentData.isAssigned) !== null && _a !== void 0 ? _a : false;
        const data = new DayPlanModule(userId, date, moduleId, moduleTitle, moduleIcon, includedDate);
        data.id = id;
        data.progress = documentData.progress;
        data.highestCorrectStreak = documentData.highestCorrectStreak;
        data.estimatedCompletionTime = documentData.estimatedCompletionTime;
        data.actualStudyTime = documentData.actualStudyTime;
        data.isFinished = documentData.isFinished;
        data.isReviewFinished = documentData.isReviewFinished;
        data.isAcquisitionFinished = documentData.isAcquisitionFinished;
        data.acquisitionTarget = documentData.acquisitionTarget;
        data.acquisitionProgress = documentData.acquisitionProgress;
        data.reviewTarget = documentData.reviewTarget;
        data.reviewProgress = documentData.reviewProgress;
        data.lastStudyDate = documentData.lastStudyDate;
        data.reviewCardIds = (_b = documentData.reviewCardIds) !== null && _b !== void 0 ? _b : [];
        data.expectedStudyDate = (_c = documentData.expectedStudyDate) !== null && _c !== void 0 ? _c : data.date;
        data.isAssigned = isAssigned;
        return data;
    }
};
